import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CardProps, CardListFilterState } from '../types';
import Card from './card';
import { toggleShowAllCards } from '../filterListSlice';

const CardList = () => {
  const dispatch = useDispatch();
  let items = useSelector((state: CardListFilterState) => state.cards);
  const selected = useSelector(
    (state: CardListFilterState) => state.selectedCards
  );
  const showAll = useSelector(
    (state: CardListFilterState) => state.showAllCards
  );
  const translations = useSelector(
    (state: CardListFilterState) => state.translations
  );

  const sectionId = useSelector(
    (state: CardListFilterState) => state.sectionId
  );

  const inNewTab = useSelector(
    (state: CardListFilterState) => state.openCardsInNewTab
  );

  const handleCardToggleClick = (shouldScroll: boolean) => {
    if (shouldScroll) {
      window.globalUtils.scrollToSection(`#${sectionId}`);
    }
    dispatch(toggleShowAllCards());
  };

  if (items && items.length > 0) {
    let selectedCards: CardProps[] = [];
    if (selected && selected.length > 0) {
      selectedCards = items.filter((card) => {
        return selected.some((x) => x == card.id);
      });
    }

    let showAllText = null;
    if (selectedCards.length > 12) {
      if (showAll) {
        showAllText = translations.less;
      } else {
        showAllText = translations.more;
        selectedCards = selectedCards.slice(0, 12);
      }
    }

    return (
      <div className={'col-12 col-xl-9'}>
        <div className='container'>
          <div className='row'>
            {selectedCards.map((item: CardProps, index: number) => {
              return (
                <Card
                  key={`card_${item.id}_${index}_${inNewTab}`}
                  {...item}
                  openInNewTab={inNewTab}
                />
              );
            })}
          </div>
          {showAllText ? (
            <div className='row'>
              <div
                className='col-12 mt-1 text-center btn btn-viewTour test'
                onClick={() => handleCardToggleClick(showAll)}
              >
                {showAllText}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default CardList;
